import { hasZspaceStaffPermissions } from '@order-management/roles';
import useUser from './user';

export function useUserHasZspaceStaffPermissions() {
  const { user: currentUser } = useUser();

  return hasZspaceStaffPermissions(currentUser);
}

export default useUserHasZspaceStaffPermissions;
